export default __webpack_public_path__ + "b63544f9140fdb4bb8f9b87dc44b7a40.png";